// src/utils/api.js

export const getApiUrl = (endpoint) => {
  const isLocal = window.location.hostname === "localhost";

  const baseUrl = isLocal
    ? "http://127.0.0.1:5001/socios-gciamt-16832/us-central1"
    : "https://us-central1-socios-gciamt-16832.cloudfunctions.net";

  return `${baseUrl}/${endpoint}`;
};